import utils from '../utils'
import apiClient from './AxiosHttp'

const getStats = (params) => {
    return apiClient.get(`/dashboard/stats/`)
}

const getUsers = (params) => {
    return apiClient.get(`/dashboard/users/list/${params}`)
}

const updateUser = (id, details) => {
    return apiClient.patch(
        `/dashboard/user/modify/${id}/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteUser = (id) => {
    return apiClient.delete(`/dashboard/user/modify/${id}/`)
}

const addUser = (details) => {
    return apiClient.post(
        `/dashboard/user/create/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const servicesStats = () => {
    return apiClient.get(`/dashboard/metrics/services/`)
}

const getCategories = () => {
    return apiClient.get('/dashboard/categories/create/list/')
}

const addCategory = (details) => {
    return apiClient.post('/dashboard/categories/create/list/', details)
}

const updateCategory = (id, details) => {
    return apiClient.patch(`/dashboard/categories/modify/${id}/`, details)
}

const deleteCategory = (id) => {
    return apiClient.delete(`/dashboard/categories/modify/${id}/`)
}

const getServices = () => {
    return apiClient.get('/dashboard/skills/create/list/');
};

const addService = (details) => {
    return apiClient.post('/dashboard/skills/create/list/', details);
};

const updateService = (id, details) => {
    return apiClient.patch(`/dashboard/skills/modify/${id}/`, details);
};

const deleteService = (id) => {
    return apiClient.delete(`/dashboard/skills/modify/${id}/`);
};

const nursesStats = () => {
    return apiClient.get(`/dashboard/metrics/nurses/`)
}

const getNurses = (params) => {
    return apiClient.get(`/dashboard/nurses/create/list/${params}`);
};

const addNurse = (details) => {
    return apiClient.post(
        '/dashboard/nurses/create/list/',
        details,
        { headers: utils.multipartHeader }
    );
};

const getNurse = (id) => {
    return apiClient.get(`/dashboard/nurses/modify/${id}/`);
};

const updateNurse = (id, details) => {
    return apiClient.patch(
        `/dashboard/nurses/modify/${id}/`,
        details,
        { headers: utils.multipartHeader }
    );
};

const deleteNurse = (id) => {
    return apiClient.delete(`/dashboard/nurses/modify/${id}/`);
};

const addLocation = (details) => {
    return apiClient.post('/taxonomies/locations/create/', details);
}

const updateLocation = (id, details) => {
    return apiClient.patch(`/taxonomies/locations/get/${id}/`, details);
}


const patientStats = () => {
    return apiClient.get(`/dashboard/metrics/patients/`)
}

const getPatients = (params) => {
    return apiClient.get(`/dashboard/patients/create/list/${params}`);
};

const addPatient = (details) => {
    return apiClient.post(
        '/dashboard/patients/create/list/',
        details,
    );
};

const getPatient = (id) => {
    return apiClient.get(`/dashboard/patients/modify/${id}/`);
};

const updatePatient = (id, details) => {
    return apiClient.patch(
        `/dashboard/patients/modify/${id}/`,
        details,
    );
};

const deletePatient = (id) => {
    return apiClient.delete(`/dashboard/patients/modify/${id}/`);
};

const getCounties = () => {
    return apiClient.get('/dashboard/counties/create/list/');
};

const addCounty = (details) => {
    return apiClient.post('/dashboard/counties/create/list/', details);
};

const updateCounty = (id, details) => {
    return apiClient.patch(`/dashboard/counties/modify/${id}/`, details);
};

const deleteCounty = (id) => {
    return apiClient.delete(`/dashboard/counties/modify/${id}/`);
};

const requestStats = () => {
    return apiClient.get(`/dashboard/metrics/requests/`);
};

const getRequests = (params) => {
    return apiClient.get(`/dashboard/requests/create/list/${params}`);
};

const addRequest = (details) => {
    return apiClient.post(
        '/dashboard/requests/create/list/',
        details
    );
};

const getRequest = (id) => {
    return apiClient.get(`/dashboard/requests/modify/${id}/`);
};

const updateRequest = (id, details) => {
    return apiClient.patch(
        `/dashboard/requests/modify/${id}/`,
        details
    );
};

const registrationCharts = (params) => {
    return apiClient.get(`/dashboard/metrics/registration/charts/${params}`);
}

const getRequestNurses = (id) => {
    return apiClient.get(`/bookings/get/nurses/${id}/`);
}

const assignNurseToRequest = (data) => {
    return apiClient.post('bookings/nurse/accept/assignment/', data)
}

const updateNurseRequest = (id, data) => {

}

const getAssignedNurses = (params) => {
    return apiClient.get(`dashboard/assignments/create/list/${params}`)
}

const nurseRequestCharts = (params) => {
    return apiClient.get(`/dashboard/metrics/requests/charts/${params}`);
}



const createProduct = (details) => {
    return apiClient.post(
        `/dashboard/products/create/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const updateProduct = (id, details) => {
    return apiClient.patch(
        `/dashboard/products/get/${id}/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteProduct = (id) => {
    return apiClient.delete(`/dashboard/products/get/${id}/`)
}

const addProductMedia = (details) => {
    return apiClient.post(
        `/dashboard/product/media/create/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteProductMedia = (id) => {
    return apiClient.delete(`/dashboard/product/media/delete/${id}/`)
}

const getPayments = (params) => {
    return apiClient.get(`/dashboard/payments/list/${params}`)
}

const updatePayment = (id, details) => {
    return apiClient.patch(`/dashboard/payments/modify/${id}/`, details)
}

const getPaymentStats = (params) => {
    return apiClient.get('/dashboard/metrics/payments/');
}

const deleteProductType = (id) => {
    return apiClient.delete(`/dashboard/product/type/get/${id}/`)
}

const updateProductType = (id, data) => {
    return apiClient.patch(
        `/dashboard/product/type/get/${id}/`,
        data,
        { headers: utils.multipartHeader }
    )
}


const adminServices = {
    getStats,
    getUsers,
    updateUser,
    deleteUser,
    addUser,
    servicesStats,
    getCategories,
    addCategory,
    updateCategory,
    deleteCategory,
    addService,
    updateService,
    deleteService,
    nursesStats,
    getNurses,
    addNurse,
    getNurse,
    updateNurse,
    deleteNurse,
    addLocation,
    updateLocation,
    patientStats,
    getPatients,
    addPatient,
    getPatient,
    updatePatient,
    deletePatient,
    getCounties,
    addCounty,
    updateCounty,
    deleteCounty,
    requestStats,
    getRequests,
    addRequest,
    getRequest,
    updateRequest,
    registrationCharts,

    getRequestNurses,
    assignNurseToRequest,
    getAssignedNurses,
    updateNurseRequest,
    nurseRequestCharts,

    getPayments,
    updatePayment,
    getPaymentStats,

    createProduct,
    updateProduct,
    deleteProduct,
    addProductMedia,
    deleteProductMedia,
    getServices,
    deleteProductType,
    updateProductType,
}

export default adminServices